<template>
  <ranking-page
    endpoint="/spontan/ranking/total/points/month"
    heading-danish="Rangliste - Point seneste 30 dage"
    heading-english="Ranking - Points recent 30 days"
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
